import React from 'react';
import { Link } from 'react-router-dom';
import { Stack, Button } from 'react-bootstrap';

function NotFoundPage() {
  return (
    <div className="container text-center" style={{ marginTop: '50px' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Stack gap={2} className="col-md-5 mx-auto">
        <Link to="/">
          <Button variant="primary">Home</Button>
        </Link>
      </Stack>
    </div>
  );
}

export default NotFoundPage;